import { InfoIcon, LockSimpleIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import { Tooltip } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'

import * as S from './field-row.styled'
import type { FieldLabelProps } from './field-row.types'

export const FieldLabel = ({ depth, hint, label, locked, required }: FieldLabelProps) => (
  <S.LabelWrapper $depth={depth}>
    <Typography size="text-medium" color="primary500" as="span">
      {label}
      {required && <span aria-hidden="true"> *</span>}
    </Typography>
    {(hint || locked) && (
      <Tooltip
        trigger={
          <S.HintIcon>
            <Icon icon={locked ? LockSimpleIcon : InfoIcon} size="1.4rem" />
          </S.HintIcon>
        }
      >
        {hint}
      </Tooltip>
    )}
  </S.LabelWrapper>
)
